import { ModuleManagementState } from '@pages/organization-module-management/store/state/module-management.state';
import { SelectedInstanceState } from '@pages/organization-module-management/store/state/selected-instance.state';
import { ModulesOrderState } from '@pages/organization-module-management/store/state/modules-order.state';

export const moduleManagementState = [ModuleManagementState, SelectedInstanceState, ModulesOrderState];
